<div class="row mt-3">
    <div class="col-12 col-lg-6 col-xl-3">
        <div class="card " (click)="InstallDevices();">
            <div class="card-body">
                <h5 class="text-dark mb-0" *ngIf="totalDevices !== null && totalDevices !== undefined">
                    {{ totalDevices }}
                    <span class="float-right text-dark"><i class="fa fa-info-circle"></i></span>
                </h5>
                <p class="mb-0 text-dark small-font">Total Installed IoT Devices</p>
            </div>
        </div>
    </div>

    <div class="col-12 col-lg-6 col-xl-3">
        <div class="card " (click)="ActiveDevices();">
            <div class="card-body">
                <h5 class="text-dark mb-0" *ngIf="totalActiveDevices !== null && totalActiveDevices !== undefined">
                    {{totalActiveDevices}}
                    <span class="float-right text-dark"><i class="fa fa-list-ul"></i></span>
                </h5>
                <p class="mb-0 text-dark small-font">Total Active IoT Devices</p>
            </div>
        </div>
    </div>
    <div class="col-12 col-lg-6 col-xl-3">
        <div class="card " (click)="InactiveDevices();">
            <div class="card-body">
                <h5 class="text-dark mb-0" *ngIf="totalInactiveDevices !== null && totalInactiveDevices !== undefined">
                    {{totalInactiveDevices}}
                    <span class="float-right text-dark"><i class="fa fa-list-ul"></i></span>
                </h5>

                <p class="mb-0 text-dark small-font">Total Inactive IoT Devices</p>
            </div>
        </div>
    </div>
    <div class="col-12 col-lg-6 col-xl-3">
        <div class="card " (click)="ToiletReports();">
            <div class="card-body">
                <h5 class="text-dark mb-0" *ngIf="totalToilet !== null && totalToilet !== undefined">
                    {{totalToilet}}
                    <span class="float-right text-dark"><i class="fa fa-link"></i></span>
                </h5>

                <p class="mb-0 text-dark small-font">Total Toilet</p>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-12">
        <div id="map" class="map"></div>
    </div>
</div>


<div id="popup" class="ol-popup">
    <a href="#" id="popup-closer" class="ol-popup-closer"></a>
    <div id="popup-content"></div>
</div>